module.exports = __webpack_public_path__ + "img/ring_r_c_null_null@2x.42068a1f.png";